import { useState } from "react";
import { Button } from "@/components/ui/button";
import LoginModal from "./LoginModal";
import SignupModal from "./SignupModal";
import { Menu } from "lucide-react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center">
          <div className="p-3 h-6 rounded-lg flex items-center justify-center mb-4">
            <img
              src="/logo.png"
              alt="Perisalah"
              className="h-10"
              style={{ marginTop: "16px" }}
            />
          </div>
          <h1 className="text-2xl font-bold text-gradient">Perisalah</h1>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 items-center">
          <a href="#fitur" className="text-white hover:text-accent font-medium">
            Fitur
          </a>
          <a href="#harga" className="text-white hover:text-accent font-medium">
            Harga
          </a>
          <a
            href="#kontak"
            className="text-white hover:text-accent font-medium"
          >
            Kontak
          </a>
          <Button
            onClick={() => (window.location.href = "https://app.perisalah.ai")}
            className="button-gradient text-white font-medium"
          >
            Masuk
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden text-white">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <Menu className="h-6 w-6" />
          </Button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-md">
          <div className="flex flex-col p-4 space-y-4">
            <a
              href="#fitur"
              className="text-white hover:text-accent py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Fitur
            </a>
            <a
              href="#harga"
              className="text-white hover:text-accent py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Harga
            </a>
            <a
              href="#kontak"
              className="text-white hover:text-accent py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Kontak
            </a>
            <Button
              onClick={() =>
                (window.location.href = "https://app.perisalah.ai")
              }
              className="button-gradient text-white w-full"
            >
              Masuk
            </Button>
          </div>
        </div>
      )}

      {showLoginModal && (
        <LoginModal onClose={() => setShowLoginModal(false)} />
      )}
      {showSignupModal && (
        <SignupModal onClose={() => setShowSignupModal(false)} />
      )}
    </nav>
  );
};

export default Navbar;
